import { createListenerMiddleware } from '@reduxjs/toolkit';

import { Toaster } from '~features/toaster';
import { dialogsApi } from '~services/api/dialogs';

export const messageThrottlingNotificator = createListenerMiddleware();

messageThrottlingNotificator.startListening({
	matcher: dialogsApi.endpoints.sendMessage.matchRejected,
	effect: (action) => {
		// TODO: find workaround
		if (action.payload?.status === 429) {
			Toaster.showSuccess({
				titleKey: 'messageThrottleNotification',
				toastId: 'messages_spam',
			});
		}
	},
});
